import { useContext } from 'react';
import { SiteContext } from '@openedx/frontend-base';

import {
  Chip,
  Container,
  Form,
  FormControl,
  FormControlFeedback,
  FormLabel,
  FormGroup,
  StatefulButton,
  Icon,
} from '@openedx/paragon';
import { Close, PersonSearch } from '@openedx/paragon/icons';

import messages from './messages';
import { useMasqueradeBarData } from './hooks';
import './index.scss';

export const MasqueradeBar = () => {
  const { authenticatedUser } = useContext(SiteContext);

  const {
    canMasquerade,
    isMasquerading,
    isMasqueradingFailed,
    isMasqueradingPending,
    masqueradeInput,
    masqueradeErrorMessage,
    handleMasqueradeInputChange,
    handleClearMasquerade,
    handleMasqueradeSubmit,
    formatMessage,
  } = useMasqueradeBarData({ authenticatedUser });

  if (!canMasquerade) { return null; }

  return (
    <div className="w-100 shadow-sm">
      <Container fluid size="xl">
        <Form className="masquerade-bar w-100">
        {isMasquerading ? (
          <>
            <FormLabel inline="true" className="masquerade-form-label">
              <Icon src={PersonSearch} />
              {formatMessage(messages.ViewingAs)}
            </FormLabel>
            <Chip
              className="masquerade-chip"
              iconAfter={Close}
              onClick={handleClearMasquerade}
            >
              {masqueradeInput}
            </Chip>
          </>
        ) : (
          <>
            <FormLabel inline="true" id="masquerade-form-label" className="masquerade-form-label">
              <Icon src={PersonSearch} />
              {formatMessage(messages.ViewAs)}
            </FormLabel>
            <FormGroup isInvalid={isMasqueradingFailed} className="masquerade-form-input">
              <FormControl
                value={masqueradeInput}
                onChange={handleMasqueradeInputChange}
                floatingLabel={formatMessage(messages.StudentNameInput)}
                aria-labelledby="masquerade-form-label"
              />
              {isMasqueradingFailed && (
                <FormControlFeedback type="invalid" hasIcon={false}>
                  {formatMessage(masqueradeErrorMessage)}
                </FormControlFeedback>
              )}
            </FormGroup>
            <StatefulButton
              disabled={!masqueradeInput?.length}
              variant="brand"
              onClick={handleMasqueradeSubmit(masqueradeInput)}
              labels={{
                default: formatMessage(messages.SubmitButton),
              }}
              className="mr-3"
              state={isMasqueradingPending ? 'pending' : 'default'}
              type="submit"
            />
          </>
        )}
      </Form>
      </Container>
    </div>
  );
};

export default MasqueradeBar;
